/**
 * Constantes del dominio, espejo de los tipos ENUM de PostgreSQL.
 *
 * La base es la fuente de verdad: si estos valores se desincronizan, la base
 * rechaza la operación. Se declaran acá para que el formulario y la API los
 * compartan sin duplicar literales sueltos por el código.
 */
export const ESTADOS = ['Pendiente', 'Aprobado', 'Observado', 'Anulado'];
/** Transiciones válidas. Espejo de fn_transicionar_estado(). */
export const TRANSICIONES = {
    Pendiente: ['Aprobado', 'Observado', 'Anulado'],
    Observado: ['Pendiente', 'Anulado'],
    Aprobado: ['Anulado'],
    Anulado: [],
};
/** Observar y anular exigen justificación escrita. */
export const EXIGEN_MOTIVO = ['Observado', 'Anulado'];
export const MOTIVO_MIN = 10;
export const ROLES = ['PROCURA', 'DIRECTOR', 'GERENTE', 'ADMIN', 'CONSULTA'];
export const TIPOS_ORDEN = ['COMPRA', 'SERVICIO'];
export const TIPOS_SUMINISTRO = ['PRODUCTO', 'SERVICIO', 'AMBOS'];
export const CONDICIONES_FICHA = ['APROBADO', 'APROBADO - REGULAR', 'NO APROBADO'];
/**
 * Series de numeración: el código del formato del SIG.
 * Espejo del CHECK chk_documentos_serie_tipo.
 */
export const SERIES = {
    REQUERIMIENTO: 'LOG-FT-01',
    ORDEN: 'LOG-FT-02',
    FICHA_SELECCION: 'LOG-FT-03',
    FICHA_EVALUACION: 'LOG-FT-04',
    APROBACION_PAGO: 'LOG-FT-09',
};
/**
 * Compra y servicio comparten el código LOG-FT-02 pero llevan correlativos
 * separados, así que ambos pueden ser LOG-FT-02-004. Los distingue el subtipo,
 * igual que en el papel: «N° DE ORDEN DE SERVICIO: LOG-FT-02-004».
 */
export const SUBTIPOS = { COMPRA: 'COMPRA', SERVICIO: 'SERVICIO', NINGUNO: '-' };
/** Formato del número impreso: LOG-FT-02-004. */
export function formatearNumero(serie, correlativo) {
    return `${serie}-${String(correlativo).padStart(3, '0')}`;
}
/** El correlativo es editable, pero debe ser un entero positivo. */
export const CORRELATIVO_MIN = 1;
export const CORRELATIVO_MAX = 999_999;
export const MONEDAS = ['PEN', 'USD'];
export const IGV_POR_DEFECTO = 0.18;
/** Prefijos de RUC válidos en Perú. Espejo de fn_ruc_valido(). */
export const RUC_REGEX = /^(10|15|17|20)\d{9}$/;
export function puedeTransicionar(desde, hacia) {
    return TRANSICIONES[desde].includes(hacia);
}
export function exigeMotivo(hacia) {
    return EXIGEN_MOTIVO.includes(hacia);
}
/** Un documento aprobado o anulado ya no se edita. */
export function esEditableEstado(estado) {
    return estado === 'Pendiente' || estado === 'Observado';
}
//# sourceMappingURL=dominio.js.map